import React from "react";

import { Drawer, useTheme } from "@mui/material";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SpeedIcon from "@mui/icons-material/Speed";
import BusinessIcon from "@mui/icons-material/Business";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import HardwareOutlinedIcon from "@mui/icons-material/HardwareOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// import { ReactComponent as SE2050Logo } from "assets/SEI_SE2050_NetZero_logo_color 1.svg";
import SE2050Logo from "../../assets/SEI_SE2050_NetZero_logo_color 1.png";
import LoginButton from "components/authentication/LoginButton";
import { DrawerHeader, drawerWidth } from "Frame";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import LogoutButton from "components/authentication/LogoutButton";
import StyledButton from "../../components/button/StyledButton";

const LandingDrawer = ({ open, handleDrawerClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { isAuthenticated } = useAuth0();

  const handleClick = () => {
    window.location.reload();
  };


  return (
    <Drawer
      sx={{
        width: '50%',
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: '40%',
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <DrawerHeader>
        <img src={SE2050Logo} alt="SE 2050 Logo" width="70%" />
      </DrawerHeader>
      <Divider />
      <div
        style={{
          position: 'absolute',
          top: '40%',
          left: '14%',
          width: '70%',
          textAlign: 'center'
        }}
      >
      {isAuthenticated ? (

            <div>
              You are now logged in. Click the button below to continue to the database. <br/> <br/>
              <StyledButton label="Continue" type="filled" onClick={handleClick}></StyledButton>
            </div>

        ) : (
          <LoginButton version="landing" />
        )}
      </div>
    </Drawer>
  );
};

export default LandingDrawer;
